import axios from "axios";
const api = axios.create({baseURL : 'https://bracketapi.ir'});
export default api;